<template>
  <div class="recipe-comments">
    <div class="container">
      <CommentForm @submit="newComment()" ref="recipeForm" :recipe="recipe" />
      <CommentsGrid ref="commentGrid" :recipe="recipe" />
    </div>
  </div>
</template>
<script>
import CommentsGrid from "@/components/comment/CommentsGrid.vue";
import CommentForm from "@/components/comment/CommentForm.vue";
export default {
  components: { CommentForm, CommentsGrid },
  props: {
    recipe: { required: true }
  },
  methods: {
    newComment() {
      this.$refs.commentGrid.fetchComments();
    }
  }
};
</script>
<style lang="scss">
.recipe-comments {
  margin-top: 40px;
  padding: 40px 0;
  overflow: hidden;
  background-color: $section-background;
}
</style>
